<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/20YyQW/media/FC-9798886937848.jpg?1689450778405" alt="This image is the cover for the book Thirst at Night"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Thirst at Night
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:16px;font-family:"Arial Nova",sans-serif;'>Transport yourself to Transylvania in the 14th century with this thrilling novel that combines fantasy, horror, and romance. With lords, dukes, duchesses, vampires, and pirates, this book has something for everyone!</span></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:16px;font-family:"Arial Nova",sans-serif;'>Lord Armando, tired of his fruitless relations and visits to the tavern, finds himself drawn into the dangerous world of vampire slaying. Lady Roseabella, the eldest daughter of a duke and a duchess, longs to break free from her castle and explore the world beyond. And Garrett, Armando’s cousin, gets lost in the vampire life, leading to unexpected consequences.</span></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:16px;font-family:"Arial Nova",sans-serif;'>But the characters don’t stop there. Meiga, the cook for the count’s castle, creates succulent meals that will make your mouth water. And her granddaughter, little Saige, possesses a powerful gift that will eventually help in the fight against the thirsty vampires.</span></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:16px;font-family:"Arial Nova",sans-serif;'>This gripping and intense read will have you on the edge of your seat, balancing vampire fights with steamy romance and a classic nobility. And with strong themes of devotion and love for family, you’ll find yourself falling in love with the characters as they navigate the treacherous world of Transylvania.</span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bella Perry
      </h2>
      
      <p class="authorDescription body article"><p style='margin:0cm;margin-bottom:.0001pt;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'><span style='font-family:"Times New Roman",serif;'>Bella and her husband and her family resides in NL, in a small-town call St. Albans. She comes from a family of 13 children, there are seven brothers and six sisters. She loves the outdoors and loves to spend time in her little cottage by a beautiful river that is famous of salmon fishing. She is a nature lover. In her dreams Bella always felt she was from the past, always on a horse with a war party defending her village a woman warrior. Her passion for telling stories and writing is contagious.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?19d84753